'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
interface HomeSectionLayoutProps {
  /** Section heading */
  title: string;
  /** Optional subtitle / blurb below the title */
  subtitle?: React.ReactNode;
  /** Optional "see all" link displayed to the right of the title */
  link?: {
    href: string;
    label: string;
  };
  /** Section content */
  children: ReactNode;
  /** Additional className applied to the outer <section> */
  className?: string;
}

/**
 * Reusable layout wrapper for homepage sections.
 * Provides consistent spacing, title, optional subtitle, and optional link.
 */
export function HomeSectionLayout(t0) {
  const $ = _c(19);
  const {
    title,
    subtitle,
    link,
    children,
    className
  } = t0;
  const t1 = `py-16 ${className ?? ""}`;
  let t2;
  if ($[0] !== title) {
    t2 = <h2 className="text-3xl font-bold text-gray-900">{title}</h2>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== link) {
    t3 = link && <Link href={link.href} className="text-sm font-medium text-indigo-600 hover:text-indigo-700 flex items-center gap-1 cursor-pointer">{link.label} <ArrowRight className="w-4 h-4" /></Link>;
    $[2] = link;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <div className="flex items-center justify-between mb-2">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== subtitle) {
    t5 = subtitle && <p className="text-lg text-gray-500 mb-8 max-w-2xl">{subtitle}</p>;
    $[7] = subtitle;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== subtitle) {
    t6 = !subtitle && <div className="mb-8" />;
    $[9] = subtitle;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== children || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{t4}{t5}{t6}{children}</div>;
    $[11] = children;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t1 || $[17] !== t7) {
    t8 = <section className={t1}>{t7}</section>;
    $[16] = t1;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}